import { portUriTemplate } from '../templates/portUriTemplate';
import { PortModel } from './port.model';
import { PortCallOvertimeSnapshotModel } from './port-call-overtime-snapshot.model';

export class PortCallModel {
  public portDetails?: PortModel;
  public overtimeSnapshot?: PortCallOvertimeSnapshotModel | null;

  constructor(
    public id?: any,
    public port?: string,
    public status?: string,
    public actualArrival?: string | Date,
    public estimatedArrival?: string | Date,
    public actualDeparture?: string | Date,
    public estimatedDeparture?: string | Date,
    public sequenceOrder?: number,
    public callType?: string,
    public plannedBerthingType?: string,
    public portExpensesUSD?: number,
    public stevedoringExpensesUSD?: number,
    public agencyExpensesUSD?: number,
    public vesselFuel?: string | null,
    public isTransshipmentHub?: boolean,
    public nauticalMileDistance?: number
  ) { }

  public fromJSON(json: any): PortCallModel {
    if (json) {
      this.id = json.id;
      this.status = json.status;
      this.sequenceOrder = json.sequenceOrder;
      this.actualArrival = json.actualArrival;
      this.estimatedArrival = json.estimatedArrival;
      this.actualDeparture = json.actualDeparture;
      this.estimatedDeparture = json.estimatedDeparture;
      this.callType = json.callType;
      this.plannedBerthingType = json.plannedBerthingType;
      this.portExpensesUSD = json.portExpensesUSD;
      this.stevedoringExpensesUSD = json.stevedoringExpensesUSD;
      this.agencyExpensesUSD = json.agencyExpensesUSD;
      const nauticalMileDistance = Number(json.nauticalMileDistance);
      this.nauticalMileDistance = Number.isFinite(nauticalMileDistance)
        ? nauticalMileDistance
        : 0;
      
      // Handle vesselFuel - store the fuel ID or IRI
      if (json.vesselFuel && typeof json.vesselFuel === 'object') {
        // Prefer @id (IRI) if available, otherwise store numeric ID
        this.vesselFuel = json.vesselFuel['@id'] ?? json.vesselFuel.id ?? null;
      } else {
        this.vesselFuel = json.vesselFuel;
      }

      this.isTransshipmentHub = json.isTransshipmentHub ?? false;

      this.overtimeSnapshot = json.overtimeSnapshot
        ? new PortCallOvertimeSnapshotModel().fromJSON(json.overtimeSnapshot)
        : null;

      //Check port
      if (typeof json.port === 'object') {
        this.portDetails = new PortModel().fromJSON(json.port);
        this.port = portUriTemplate(this.portDetails.id?.toString());
      } else {
        this.portDetails = undefined;
        this.port = json.port;
      }
    }

    return this;
  }

  public fromJSONList(json: any): PortCallModel[] {
    if (json) {
      return json.map((element: any) => new PortCallModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      status: this.status,
      port: this.port,
      sequenceOrder: this.sequenceOrder,
      actualArrival: this.actualArrival,
      estimatedArrival: this.estimatedArrival,
      actualDeparture: this.actualDeparture,
      estimatedDeparture: this.estimatedDeparture,
      callType: this.callType,
      plannedBerthingType: this.plannedBerthingType,
      portExpensesUSD: this.portExpensesUSD,
      stevedoringExpensesUSD: this.stevedoringExpensesUSD,
      agencyExpensesUSD: this.agencyExpensesUSD,
      vesselFuel: this.vesselFuel,
      nauticalMileDistance: this.nauticalMileDistance,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.id ?? '';
  }
}
